import { connect } from 'react-redux';
import { assign } from 'lodash';
import BaseForm from '../BaseForm/BaseForm';
import { addAccessory, showError, clearErrors } from '../../redux/actions/accessories';

class AccessoryCreateForm extends BaseForm {
  constructor(props) {
    super(props, {
      onSubmit: addAccessory,
      name: 'Accessory',
      action: 'Add',
      type: 'create',
      isTypeForm: true,
    });
  }

  /**
   * Handle form validation
   */
  handleValidate(data, isIndex = (index: number) => true) {
    let result = data;
    if (this.props.model.didInvalidate) {
      this.props.dispatch(clearErrors());
    }
    if (isIndex(0) && BaseForm.validator.isEmpty(data.name)) {
      this.props.dispatch(showError('Please specify a name'));
      return false;
    }
    if (isIndex(2) && (!data.image || data.image.length === 0)) {
      this.props.dispatch(showError('Please choose an image'));
      return false;
    }
    if (data.image && data.image.length > 0) {
      const image = data.image[0];
      result = assign({}, data, { image });
      if (isIndex(2) && !BaseForm.validator.contains(image.type, 'image')) {
        this.props.dispatch(showError('Please choose a valid image file'));
        return false;
      }
      if (isIndex(2) && image.size >= 5 * 1024 * 1024) {
        this.props.dispatch(showError('Please choose an image under 5MB'));
        return false;
      }
    }
    if (isIndex(3) && !BaseForm.validator.isInt(data.limit)) {
      this.props.dispatch(showError('Please specify a valid limit'));
      return false;
    }
    if (isIndex(4) && !BaseForm.validator.isFloat(data.price)) {
      this.props.dispatch(showError('Please specify a price'));
      return false;
    }
    return result;
  }

  /**
   * Handle form reset
   */
  handleReset(dispatch, actions) {
    dispatch(actions.change('create.name', ''));
    dispatch(actions.change('create.image', undefined));
    dispatch(actions.change('create.description', ''));
    dispatch(actions.change('create.price', ''));
    dispatch(actions.change('create.per_day', false));
    dispatch(actions.change('create.per_driver', false));
    dispatch(actions.change('create.limit', '0'));
  }
}

const mapStateToProps = ({ accessories }) => ({
  model: accessories,
  fields: BaseForm.fields.accessories.create,
  values: {},
});

export default connect(mapStateToProps)(AccessoryCreateForm);
